// AlignJustifySmallIcon.tsx

import React from "react";

export const TextAlignRightIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M0 1.33333V0H12V1.33333H0ZM4 4V2.66667H12V4H4ZM0 6.66667V5.33333H12V6.66667H0ZM4 9.33333V8H12V9.33333H4ZM0 12V10.6667H12V12H0Z"
        fill="currentColor"
      />
    </svg>
  );
};
